@if (managerSettings().length > 0) {
  <div>
    @for (setting of managerSettings(); track setting) {
      <div>
        <input class="form-check-input"
               id="manager-checkbox-{{setting.startDate}}"
               type="checkbox"
               [(ngModel)]="setting.canDoSales"
               disabled>
        <label class="form-check-label ms-2" for="manager-checkbox-{{setting.startDate}}">
          Manager also acts as a sales person <span class="smaller-text">starting from {{ setting.startDate }}</span>
        </label>
        @if (catEditAtDate(setting.startDate)) {
          <i
                  (click)="openUpdateSettings(setting)"
                  class="fa fa-xs fa-pen pointer ms-3">
          </i>
        }
        @if (catEditAtDate(setting.startDate)) {
          <i
                  (click)="openDeleteSettings(setting.startDate)"
                  class="fa fa-xs fa-trash pointer ms-2">
          </i>
        }
      </div>
    }
  </div>
}
@if (managerSettings().length === 0) {
  <div>
    <input class="form-check-input"
           id="manager-checkbox"
           type="checkbox"
           disabled>
    <label class="form-check-label ms-2" for="manager-checkbox">
      Manager also acts as a sales person
    </label>
  </div>
}
<div (click)="openCreateSettings()" class="add-setting ms-4">
  Add the setting for manager also acting as a sales person
</div>